/**
 * This function allows to set custom css variable from javascript
 * @param {string} name
 * @param {string} value
 */
export const setCssVariable = (name, value) => {
  document.documentElement.style.setProperty(name, value);
}

/**
 * Represents a CSS variable.
 * @typedef {string[]} CssVariable
 * @property {string} 0 - The name of the CSS variable.
 * @property {string} 1 - The value of the CSS variable.
 *
 * This function allows to set a few custom css variables from javascript
 * @param {CssVariable[]} variables - An array of CSS variables.
 */
export const setCssVariables = (variables = []) => {
  variables.forEach(([name, value]) => {
    setCssVariable(name, value);
  });
}

/**
 * Transforms color from hex to rgba format.
 * @param {string} hex - color in hex format
 * @param {number} [alpha=1] - opacity
 * @returns {`rgba(${number}, ${number}, ${number}, 1)`}
 */
export const hexColorToRgba = (hex, alpha = 1) => {
  const hexColor = hex.replace(/^#/, '');

  const r = parseInt(hexColor.slice(0, 2), 16);
  const g = parseInt(hexColor.slice(2, 4), 16);
  const b = parseInt(hexColor.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
